import { useEffect } from "react";
export const useMount = effect => {
  // rijesiti warning ?
  // eslint-disable-next-line
  useEffect(effect, []);
};
